import { Link } from 'react-router-dom';
import MarketingLayout from '../components/MarketingLayout';
import layoutStyles from '../components/MarketingLayout.module.css';
import styles from './Pricing.module.css';

const TIERS = [
  {
    name: 'Free',
    price: '£0',
    headline: 'Get started',
    cta: 'Get Started Free',
    ctaHref: '/auth',
    ctaExternal: false,
    popular: false,
  },
  {
    name: 'Indie',
    price: '£29',
    headline: 'Accept payments',
    cta: 'Start Free, Upgrade Anytime',
    ctaHref: '/auth',
    ctaExternal: false,
    popular: true,
  },
  {
    name: 'Builder',
    price: '£99',
    headline: 'Scale your business',
    cta: 'Start Free, Upgrade Anytime',
    ctaHref: '/auth',
    ctaExternal: false,
    popular: false,
  },
  {
    name: 'Scale',
    price: '£299',
    headline: 'Enterprise ready',
    cta: 'Contact Us',
    ctaHref: 'mailto:matt@whisker1.com',
    ctaExternal: true,
    popular: false,
  },
];

const FEATURES = [
  { label: 'Bookings/month',        free: '1,000',     indie: '1,000',  builder: '10,000',    scale: '50,000'    },
  { label: 'Calendar connections',  free: '1',         indie: '5',      builder: 'Unlimited', scale: 'Unlimited' },
  { label: 'Venn Links',            free: true,        indie: true,     builder: true,        scale: true        },
  { label: 'Calendar sync',         free: true,        indie: true,     builder: true,        scale: true        },
  { label: 'Paid bookings (Stripe)',free: false,       indie: true,     builder: true,        scale: true        },
  { label: 'Webhook delivery',      free: false,       indie: true,     builder: true,        scale: true        },
  { label: 'Priority support',      free: false,       indie: true,     builder: true,        scale: true        },
  { label: 'SLA support',           free: false,       indie: false,    builder: true,        scale: true        },
  { label: 'Custom integrations',   free: false,       indie: false,    builder: true,        scale: true        },
  { label: 'Dedicated support',     free: false,       indie: false,    builder: false,       scale: true        },
  { label: 'Custom SLA',            free: false,       indie: false,    builder: false,       scale: true        },
];

function FeatureCell({ value }) {
  if (value === true) return <span className={styles.check} aria-label="Included">✅</span>;
  if (value === false) return <span className={styles.cross} aria-label="Not included">❌</span>;
  return <span className={styles.cellText}>{value}</span>;
}

export default function Pricing() {
  return (
    <MarketingLayout>

        {/* ── Header ── */}
        <section className={styles.header}>
          <div className={layoutStyles.sectionInner}>
            <div className="section-label">Pricing</div>
            <h1 className={styles.headline}>Simple, transparent pricing</h1>
            <p className={styles.sub}>
              Start free. No credit card required.
            </p>
            <p className={styles.annualNote}>Save with annual billing — coming soon</p>
          </div>
        </section>

        {/* ── Tier cards ── */}
        <section className={styles.tiersSection}>
          <div className={layoutStyles.sectionInner}>
            <div className={styles.tiersGrid}>
              {TIERS.map((tier) => (
                <div
                  key={tier.name}
                  className={`${styles.tierCard} ${tier.popular ? styles.tierCardPopular : ''}`}
                >
                  {tier.popular && (
                    <span className={styles.popularBadge}>Most Popular</span>
                  )}
                  <div className={styles.tierName}>{tier.name}</div>
                  <div className={styles.tierPrice}>
                    {tier.price}
                    <span className={styles.tierPer}>/mo</span>
                  </div>
                  <div className={styles.tierHeadline}>{tier.headline}</div>
                  {tier.ctaExternal ? (
                    <a
                      href={tier.ctaHref}
                      className={`btn ${tier.popular ? 'btn-primary' : ''} ${styles.tierCta}`}
                    >
                      {tier.cta}
                    </a>
                  ) : (
                    <Link
                      to={tier.ctaHref}
                      className={`btn ${tier.popular ? 'btn-primary' : ''} ${styles.tierCta}`}
                    >
                      {tier.cta}
                    </Link>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── Feature comparison table ── */}
        <section className={`${layoutStyles.section} ${layoutStyles.sectionWarm}`}>
          <div className={layoutStyles.sectionInner}>
            <div className="section-label">Compare plans</div>
            <div className={styles.tableWrap}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    <th className={styles.thFeature}>Feature</th>
                    {TIERS.map((t) => (
                      <th key={t.name} className={styles.thTier}>{t.name}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {FEATURES.map((row) => (
                    <tr key={row.label} className={styles.tableRow}>
                      <td className={styles.tdFeature}>{row.label}</td>
                      <td className={styles.tdCell}><FeatureCell value={row.free} /></td>
                      <td className={styles.tdCell}><FeatureCell value={row.indie} /></td>
                      <td className={styles.tdCell}><FeatureCell value={row.builder} /></td>
                      <td className={styles.tdCell}><FeatureCell value={row.scale} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

    </MarketingLayout>
  );
}
